import { vexInfoData } from 'variables/general'

import { InfoIcon } from '@chakra-ui/icons'
import { Flex, FormLabel, Tooltip } from '@chakra-ui/react'

import { useThemeColor } from 'hooks/useThemeColors'

const InfoLabel = ({ title, name }) => {
  const onCheck = (title) => {
    const result = vexInfoData?.find((item) => item?.title === title)
    return result?.desc
  }
  const { primaryBlueText } = useThemeColor(['primaryBlueText'])

  return (
    <Flex flexDirection={'row'} alignItems={'center'} gap={2} mb={1}>
      <FormLabel mx={0} p={0} htmlFor={name} mb={2}>
        {title}
      </FormLabel>
      <Tooltip label={onCheck(title)}>
        <InfoIcon mb={1.5} color={primaryBlueText} />
      </Tooltip>
    </Flex>
  )
}

export default InfoLabel
